import { toMoney, toPercent } from './number';

export { toMoney, toPercent };
